import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import { DownloadButton } from "./DownloadButton";

export function PDFDownload({ onClick }) {
    const location = useLocation();

    return (
        <DownloadButton
            onClick={() => onClick(location.pathname)}
            data-testid="pdf-download-button"
        >
            PDF
        </DownloadButton>
    );
}

PDFDownload.propTypes = {
    onClick: PropTypes.func
};
